export default "__VITE_ASSET__3TYWOGin__"